export const NON_SUPPORTED_LANGUAGES = ['hi'];
export const BI_MICRO_CATEGORIES_CLICK_SOURCE = 'explore_more_tags';
